import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { Accordion, AccordionDetails, AccordionSummary, Typography, styled, Box, IconButton } from "__barrel_optimize__?names=Accordion,AccordionDetails,AccordionSummary,Box,IconButton,Typography,styled!=!@mui/material";
const StyledAccordionSummary = styled(AccordionSummary)({
    padding: "unset",
    justifyContent: "flex-start",
    minHeight: "unset !important",
    gap: "10px",
    alignItems: "flex-start",
    "& .MuiAccordionSummary-content": {
        flexGrow: "unset ",
        marginTop: "unset !important",
        marginBottom: "10px !important"
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: "#000"
    }
});
const CollapsibleSection = (param)=>{
    let { title, children, style, renderTitle, iconSize, headerActions, secondaryAction, secondaryActionIcon } = param;
    const hasHeaderActions = Boolean(headerActions || secondaryAction);
    return /*#__PURE__*/ _jsxs(Accordion, {
        elevation: 0,
        defaultExpanded: true,
        style: style,
        sx: {
            "&::before": {
                display: "none"
            }
        },
        children: [
            /*#__PURE__*/ _jsx(StyledAccordionSummary, {
                expandIcon: /*#__PURE__*/ _jsx(ArrowDropDownOutlinedIcon, {
                    sx: {
                        fontSize: iconSize ? iconSize : "24px"
                    }
                }),
                sx: hasHeaderActions ? {
                    "& .MuiAccordionSummary-content": {
                        flexGrow: 1,
                        width: "100%"
                    }
                } : undefined,
                children: /*#__PURE__*/ _jsxs(Box, {
                    position: "relative",
                    sx: {
                        width: hasHeaderActions ? "100%" : undefined
                    },
                    children: [
                        renderTitle ? renderTitle() : /*#__PURE__*/ _jsx(Typography, {
                            fontWeight: "500",
                            variant: "h6",
                            fontSize: "18px",
                            lineHeight: "28px",
                            children: title
                        }),
                        hasHeaderActions && /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                position: "absolute",
                                right: 0,
                                top: "-10px",
                                display: "flex",
                                alignItems: "center"
                            },
                            onClick: (e)=>e.stopPropagation(),
                            children: [
                                headerActions,
                                secondaryAction && /*#__PURE__*/ _jsx(IconButton, {
                                    sx: {
                                        width: "34px",
                                        height: "34px",
                                        "& path": {
                                            fill: "red",
                                            "&:hover": {
                                                backgroundColor: "none !important"
                                            }
                                        }
                                    },
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        secondaryAction(e);
                                    },
                                    children: secondaryActionIcon && secondaryActionIcon
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(AccordionDetails, {
                sx: {
                    padding: "unset",
                    paddingTop: "10px"
                },
                children: children
            })
        ]
    });
};
export default CollapsibleSection;
